import React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type SupplementForm from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/SupplementForm'

interface Props {
  options: { label: string; value: number }[]
  form: SupplementForm
  onChangeTaxonomy: (value: number) => void
  setModalOpen: (value: boolean) => void
}

const TaxonomyPopoverContent = ({ options, form, onChangeTaxonomy, setModalOpen }: Props) => {
  const taxonomyValue = Number(form.get('contracts_taxonomy_id').value)

  return (
    <Box gap="s16" paddingX="s24" paddingY="s12" aria-label="taxonomy-content">
      <Selector.Container
        searchPlaceholder={i18n.t('common.search')}
        blankLabel={i18n.t('common.empty')}
        value={[taxonomyValue]}
        onChange={(selection) => {
          onChangeTaxonomy(Number(selection))
        }}
      >
        {options.map((option) => (
          <Selector.Option
            key={option.value}
            value={option.value}
            label={option.label || ''}
            searchValue={option.label || ''}
            isHidden={option.value === taxonomyValue}
          >
            {option.label}
          </Selector.Option>
        ))}
      </Selector.Container>

      <Box
        paddingX="s12"
        paddingTop="s12"
        paddingBottom="s0"
        border={{ top: { color: 'grey400', width: 's1', style: 'solid' } }}
      >
        <Button
          iconName="add"
          type="secondary"
          onClick={() => {
            setModalOpen(true)
          }}
        >
          {i18n.t('handoffs.supplements.create_taxonomy.create_button')}
        </Button>
      </Box>
    </Box>
  )
}

export default observer(TaxonomyPopoverContent)
